angular.module('lf.common')

.directive('carousel', function ($parse, $compile, gtmService) {
  return {
    restrict: 'EA',
    link: function (scope, el, attrs) {
      var client = lf.data.xhr.client;
      var isMobile = client.isMobile || client.mobileUI;
      var isDesktop = client.isDesktop || client.isLFC;
      var isAndroid = /android/i.test(navigator.userAgent);
      var carousel;
      var itemsCount = el.children().length;
      var $btnPrev = $('<div class="ui-carousel__btn-prev"><i class="fa fa-angle-left"></i></div>');
      var $btnNext = $('<div class="ui-carousel__btn-next"><i class="fa fa-angle-right"></i></div>');

      var defaults = {
        loop: false,
        responsiveClass: true,
        mouseDrag: true,
        touchDrag: true,
        nav: true
      }
      
      if (isDesktop) {
        $.extend(defaults, {
          mouseDrag: false,
          useTranslate3d: false,
          dots: false
        });
      }
      
      if (isMobile) {
        var itemsPerPage = $(window).width() >= 600 ? 3 : 1;
        $.extend(defaults, {
          responsive: {
            0: { items: 1 },
            600: { items: 3, slideBy: 3 }
          },
          dots: itemsPerPage === 1
        });
      }
      
      if (itemsCount > 10) {
        defaults.dots = false;
      }
      if (itemsCount === 1) {
        $.extend(defaults, {
          nav: false,
          loop: false,
          dots: false
        });
      }
      
      if (client.mode === 'lpu') {
        defaults.dragThreshold = 30;
      }
      
      var opts = $parse(attrs.carouselOptions)(scope) || {};
      opts = $.extend(true, {}, defaults, opts);
      
      if (opts.mode === 'extended-width') {
        var carouselWidth = (opts.items + 1) * (opts.itemWidth || 0);
        opts = {
          nav: false,
          dots: false,
          loop: opts.loop || false,
          responsive: {
            600: { items: opts.items + 1, slideBy: 1 }
          }
        }
        if (carouselWidth) {
          el.css('width', carouselWidth);
        }
        if (!opts.loop) {
          el.append('<div class="carousel__item"></div>');
        }
      }
      
      var $owlCarousel = el.owlCarousel(opts);

      if (opts.loop) {
        var $cloned = el.find('.owl-item.cloned > .carousel__item');
        $compile($cloned)(scope);
      }
      
      var broadcartGTMEvent = function (activeEl, action) {
        if (activeEl) {
          var index = activeEl.index();

          if (activeEl.find('div.product-pod').length) {
            var productId = activeEl.find('div.product-pod').attr('data-ga-prod-id');

            gtmService.pushProductsCarousel({index: index, prodId: productId, action: action});
          } else {
            var imageSrc = activeEl.find('img').attr('src');

            gtmService.pushScreenshotsCarousel({index: index, sourceURL: imageSrc, action: action});
          }
        }
      };

      var broadcastNavigate = function (e, data) {
        broadcartGTMEvent(data.el, 'Navigate To Item');
      }

      carousel = el.data('owlCarousel');
      
      el.on('changed.owl.carousel', function (e) {
        if (opts.nav && !opts.loop) {
          if (e.item.index === 0) {
            $btnPrev.hide();
            $btnNext.show();
          } else if ((e.item.index + carousel.settings.items) === e.item.count) {
            $btnPrev.show();
            $btnNext.hide();
          } else {
            $btnPrev.show();
            $btnNext.show();
          }
        }
      });
      
      el.on('resized.owl.carousel', function (e) {
//        console.log('owl resized');
//        updateNavButtons();
      });

      $owlCarousel.bind('owlCarouselSlide', function (e, data) {
        var action = data.forward ? 'Forward Slide' : 'Backward Slide';
        broadcartGTMEvent(data.el, action);
      });

      $owlCarousel.bind('owlCarouselNavigate', broadcastNavigate);

      var stageEl = el.find('div.owl-stage');
      broadcartGTMEvent(stageEl.children('div.active'));

      if (opts.nav) {
        $btnPrev.on('click', function (e) {
          el.trigger('prev.owl.carousel', [300]);
          broadcartGTMEvent(stageEl.find('div.active'), 'Backward Arrow');
        });
        $btnNext.on('click', function (e) {
          el.trigger('next.owl.carousel', [300]);
          broadcartGTMEvent(stageEl.find('div.active'), 'Forward Arrow');
        });

        var $outer = el.find('.owl-stage-outer');
        var $img = $outer.find('.owl-item img.media-item:first, .owl-item img.thumb:first');
        var stageHeight = $outer.outerHeight();
        var css = {
          height: stageHeight,
          lineHeight: stageHeight + 'px'
        }
        var onImageLoad = function onImageLoad () {
          var height = $img.outerHeight();
          css = {
            height: height,
            lineHeight: height + 'px'
          }
          showNavButtons(css);
        }
        
        if ($img.length) {
          if ($img[0].complete) {
            onImageLoad();
          } else {
            $img.on('load', onImageLoad);
          }
        }
        
        showNavButtons(css);
        
        el.append($btnPrev)
          .append($btnNext);
      }
      
      function showNavButtons (css) {
        if (css) {
          $btnPrev.css(css);
          $btnNext.css(css);
        }
        
        if (opts.loop) {
          $btnPrev.show();
          $btnNext.show();
        } else {
          $btnPrev.hide();
          if (itemsCount > carousel.settings.items) {
            $btnNext.show();
          }
        }
      }
      
      scope.$on('$destroy', function () {
        carousel.destroy();
        $btnPrev = null;
        $btnNext = null;
      });
      
    }
  }
});
